import { performRequest } from "../performRequest"



export const getAllDocumentApi = (params) => {
    return performRequest("get", "api/ess/documents/",params)
}

export const exportDocumentsApi = (params) => {
    return performRequest("get", "api/ess/documents/", { ...params, export: "xlsx" }, true, "blob")
}

export const getDocumentDetailApi = (id, params) => {
    return performRequest("get", `api/ess/documents/${id}/`,params)
}


export const postDocumentApi = (params) => {
    const company = localStorage.getItem('company') || 1

    params[0].company = company

    return performRequest("post", `api/ess/documents/`,params)
}

export const updateDocumentApi = (id, params) => {
    const company = localStorage.getItem('company') || 1
    // params[0]
    params.company = company
    console.log(params, "JJJJJ")
    
    return performRequest("put", `api/ess/documents/${id}/`,params)
}



export const deleteDocumentApi = (id) => {
    return performRequest("delete", `api/ess/documents/${id}/`)
}


export const getAllDocumentTypeApi = (params) => {
    return performRequest("get", "api/ess/documents-type/",params)
}


export const getDocumentStatsApi = (params) => {
    return performRequest("get", "api/ess/documents/stats/", params)
}

export const archiveDocumentApi = (id) => {
    return performRequest("post", `api/ess/documents/${id}/archive/`)
}

export const restoreDocumentApi = (id) => {
    return performRequest("post", `api/ess/documents/${id}/restore/`)
}

export const getGroupedDocumentsApi = (params) => {
    return performRequest("get", "api/ess/documents/grouped/", params)
}
